var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08154 25.9038C9.08154 28.1944 7.21342 30.0653 4.92248 30.0653C2.63154 30.0653 0.76123 28.1944 0.76123 25.9038C0.76123 23.6131 2.63217 21.7422 4.92279 21.7422H9.08186L9.08154 25.9038ZM11.1781 25.9038C11.1781 23.6131 13.049 21.7422 15.3397 21.7422C17.6303 21.7422 19.5012 23.6128 19.5012 25.9038V36.3209C19.5012 38.6116 17.6306 40.4825 15.3397 40.4825C13.049 40.4825 11.1781 38.6116 11.1781 36.3209V25.9038Z",
    fill: "#DE1C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3397 9.19629C13.049 9.19629 11.1781 7.32816 11.1781 5.03723C11.1781 2.74629 13.049 0.875977 15.3397 0.875977C17.6303 0.875977 19.5012 2.74691 19.5012 5.03754V9.1966L15.3397 9.19629ZM15.3397 11.2929C17.6303 11.2929 19.5012 13.1638 19.5012 15.4544C19.5012 17.745 17.6306 19.616 15.3397 19.616H4.92248C2.63186 19.616 0.76123 17.7453 0.76123 15.4544C0.76123 13.1638 2.63217 11.2929 4.92279 11.2929H15.3397Z",
    fill: "#35C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0471 15.4544C32.0471 13.1638 33.9153 11.2929 36.2062 11.2929C38.4971 11.2929 40.3678 13.1638 40.3678 15.4544C40.3678 17.745 38.4968 19.616 36.2062 19.616H32.0471V15.4544ZM29.9506 15.4544C29.9506 17.745 28.0796 19.616 25.789 19.616C23.4984 19.616 21.6274 17.7453 21.6274 15.4544V5.03723C21.6274 2.7466 23.4981 0.875977 25.789 0.875977C28.0796 0.875977 29.9506 2.74691 29.9506 5.03754V15.4544Z",
    fill: "#2EB57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.789 32.1619C28.0796 32.1619 29.9506 34.03 29.9506 36.3209C29.9506 38.6119 28.0796 40.4825 25.789 40.4825C23.4984 40.4825 21.6274 38.6116 21.6274 36.3209V32.1619H25.789ZM25.789 30.0653C23.4984 30.0653 21.6274 28.1944 21.6274 25.9038C21.6274 23.6131 23.4981 21.7422 25.789 21.7422H36.2062C38.4968 21.7422 40.3678 23.6128 40.3678 25.9038C40.3678 28.1944 38.4968 30.0653 36.2062 30.0653H25.789Z",
    fill: "#EBB02E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.564453 0.678711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.c9087974075633497f1183e1ffd9061b.svg";
export { ForwardRef as ReactComponent };